<template>
    <div class="overflow-x-hidden">
        <section
            class="educators-section text-center  grid flex flex-wrap justify-content-center align-items-center py-2 px-4 md:px-6 relative">
            <img src="@/assets/Images/bird.png" alt="" class="decoration">
            <img src="@/assets/Images/coconut-trees.png" alt="" class="decoration-trees">
            <div class="col-10 relative">
                <span class="badge mb-2">For Educators</span>
                <h2 class="mb-2 LandingPage-Title">
                    Share your skills. Empower your life.
                </h2>
                <p class="Paragraph-Regular mx-auto">
                    Join Sri Lanka's premier teaching platform and connect with students who need your expertise. Make a
                    difference while earning competitive income on your own terms.
                </p>
            </div>
            <div
                class="container px-4 md:px-6 md:pt-4 grid flex flex-wrap justify-content-center align-items-center relative">
                <div class="grid align-items-center col-11  ">
                    <!-- Left Content -->
                    <div class="col-12 lg:col-6">
                        <div class="educators-content ">
                            <img :src="bgUrl" alt="Expert Educators" class="w-full border-round-lg shadow-2"
                                style="max-height: 500px; object-fit: cover;">
                        </div>
                    </div>

                    <!-- Right Content - Benefits Grid -->
                    <div class="col-12 lg:col-6 flex flex-column justify-content-center align-items-center ">
                        <div class="grid flex flex-column justify-content-center align-items-center " v-animateonscroll="{ enterClass: 'animate-enter slide-in-right' }">
                            <div v-for="(benefit, index) in benefits" :key="index" class="col-12" >
                                <div class="benefit-card " >
                                    <div class="flex align-items-center gap-3">
                                        <div
                                            class="icon-container flex align-items-center justify-content-center mt-1">
                                            <i :class="benefit.icon"></i>
                                        </div>
                                        <div>
                                            <h4 class="Paragraph-Medium text-left mb-1">{{ benefit.title }}
                                            </h4>
                                            <p class="text-left Label mb-0 mt-0">{{ benefit.description }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script setup>
import { ref } from 'vue';
import { usePublicUrl } from "@/utils/getPublicUrl"

const bgUrl = usePublicUrl("public/skills-section.jpg");
const benefits = ref([
    {
        icon: "pi pi-globe",
        title: "Wider Reach",
        description: "Connect with students from all across Sri Lanka - online or in-person"
    },
    {
        icon: "pi pi-calendar",
        title: "Flexible Schedule",
        description: "Set your own hours and teach when it works best for you"
    },
    {
        icon: "pi pi-dollar",
        title: "Competitive Earnings",
        description: "Set your own rates and earn what you deserve with no middlemen"
    },
    {
        icon: "pi pi-star",
        title: "Recognition & Credibility",
        description: "Build your teaching profile and gain reviews from happy students"
    },
    {
        icon: "pi pi-mobile",
        title: "Easy-to-Use Platform",
        description: "Simple, mobile-friendly platform designed for smooth communication and scheduling"
    },
    {
        icon: "pi pi-shield",
        title: "Secure Payments",
        description: "Reliable, transparent payment system for every completed session"
    },
    {
        icon: "pi pi-megaphone",
        title: "Marketing Support",
        description: "We help promote your profile to attract more students"
    },
    {
        icon: "pi pi-chart-line",
        title: "Growth Opportunities",
        description: "Expand your teaching business with our growing student community"
    }
]);
</script>
<style scoped>
.LandingPage-Title {
    color: #1D97BD;
}

.educators-content img {
    width: 100%;
    height: auto;
    max-height: 500px;
    object-fit: cover;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.decoration {
    position: absolute;
    top: 23%;
    left: 0;
    z-index: 1;
    height: 270px;
    object-fit: contain;
    transform: scaleX(-1);

}

.decoration-trees {
    position: absolute;
    top: 55%;
    left: 0;
    z-index: 1;
    height: 350px;
    object-fit: contain;

}

/* Responsive styles */
@media (max-width: 768px) {
    .decoration {
        display: none;
    }
}

@media (max-width: 480px) {
    .decoration-trees {
        display: none;
    }
}
</style>